export const LIVE_WALL_HOMEPAGE = '';

export const DEFAULT_GRID_WIDTH = 3;
export const DEFAULT_GRID_HEIGHT = 3;
export const MAXIMUM_GRID_WIDTH = 20;
export const MAXIMUM_GRID_HEIGHT = 20;
export const LIVEWALL_RETRY_TIMEOUT = 5 * 1000;
export const LIVEWALL_RETRY_LIMIT = 5;
export const LOCAL_STORAGE_LIVEWALL_CONFIG = 'icetana-livewall-config';
